export default "__VITE_ASSET__PyLr55Pl__"